// extracted by mini-css-extract-plugin
export default {"alfa":"GroupeEmail_alfa__i+D0L","btadd":"GroupeEmail_btadd__EZMVJ","creer":"GroupeEmail_creer__zppEQ","comtnet":"GroupeEmail_comtnet__q+hnd","fontSize":"GroupeEmail_fontSize__rFht0"};